import { config } from "../../config";
import { HttpServices } from "../../Helper";

export const GetAgentCommissionSummary = async (body) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/AgentAchievementCommission/GetAgentCommissionSummary`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};
export const GetAgentCommissionTransactions = async (body) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/AgentAchievementCommission/GetAgentCommissionTransactions`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};
export const UpdateAgentCommissionTransaction = async (body, id) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/AgentAchievementCommission/UpdateAgentCommissionTransaction/${id}`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};
